/** i18n dictionary */
export default {
  landing:{
    header: "Date: Oct. 19-22, 2020",
    subheader: "Hall: 4.1 Booth: M09",
    products_overview: "Products Overview",
    events_and_news: "Events and News",
    make_appointment: "Book appointment",
    form_header: "Interested in being a distributor?",
    phone_tab: "Mobile phone",
    phone_placeholder: "Please type your phone here",
    email_tab: "Email",
    email_placeholder: "Please type your email here",
    submit_button: "Send",
    confirmation_text: "We have received your information. Someone from Orantech will reach out to you shortly."
  },
  make_appointment: {
    title: "Book appointment",
    date_slot_header: "Pick a date",
    date_field_text: "*Date:",
    date_dropdown_options: [
      {text: "- date -" , value: "", disabled: true},
      {text: "Oct. 19" , value: "2020-10-19"},
      {text: "Oct. 20" , value: "2020-10-20"},
      {text: "Oct. 21" , value: "2020-10-21"},
      {text: "Oct. 22" , value: "2020-10-22"},
    ],
    time_slot_header: "Pick a time",
    time_field_text: "*Time:",
    time_dropdown_options: [
      {text: "- time -" , value: "", disabled: true},
      {text: "9:30 AM", value: "9:30 AM"},
      {text: "10:00 AM", value: "10:00 AM"},
      {text: "10:30 AM", value: "10:30 AM"},
      {text: "11:00 AM", value: "11:00 AM"},
      {text: "11:30 AM", value: "11:30 AM"},
      {text: "12:00 PM", value: "12:00 PM"},
      {text: "12:30 PM", value: "12:30 PM"},
      {text: "1:00 PM",  value: "1:00 PM" },
      {text: "1:30 PM",  value: "1:30 PM" },
      {text: "2:00 PM",  value: "2:00 PM" },
      {text: "2:30 PM",  value: "2:30 PM" },
      {text: "3:00 PM",  value: "3:00 PM" },
      {text: "3:30 PM",  value: "3:30 PM" },
      {text: "4:00 PM",  value: "4:00 PM" },
      {text: "4:30 PM",  value: "4:30 PM" },
      {text: "5:00 PM",  value: "5:00 PM" },
    ],
    first_name_field_text: "*First name:",
    last_name_field_text: "*Last name:",
    email_field_text: "Email:",
    mobile_phone_field_text: "*Phone:",
    submit_button_text: "Book appointment",
    confirmation_text: "Your booking has been received. Someone from Orantech will reach out to you soon.",
  },
  about_us: {
    title: "About Us",
    verbiage: `Orantech is the leading manufacturer of top quality patient monitor compatible cables and sensors. We produce accessories for the most
    popular patient monitors by brands like GE, Phillips, Masimo, Nellcor, Mindray, Nihon Koden, Datex and many more. All our products are manufactured to function equivalent to OEMs. Accurate sensitivity and signal response combined with reliable performance and durability make our price-conscious products popular in major hospitals as well as specialized clinics. We also manufacture OEM
    parts by contract.`,
    video_url: "https://orantech-images.s3-ap-southeast-1.amazonaws.com/Orantech+Company+Video+English+Mobile+App.mov",
  },
  products: {
    download_brochures: "Download Brochures",
    view_more: "View more",
    view_fewer: "View fewer",
  },
  events: {
    title: "Events and News"
  },
  team: {
    title: "Meet our MEDICA Team",
    verbiage: "These are our team members that you will meet at MEDICA. We produce accessories for the most popular patient monitors by brands like GE, Phillips, Masimo, Nellcor, Mindra, Nihon Koden, Datex and many more. All our products are manufactured to function equivalent to OEMs. Accurate sensitivity and signal response combined with reliable performance and durability make our price-conscious products popular in major hospitals as well as specialized clinics. We also manufacture OEM parts by contract.",
    contact_header: "Contact",
    email_field_text: "Email:",
    phone_field_text: "Phone:",
  },
}